import { render, staticRenderFns } from "./eight.vue?vue&type=template&id=52878398&scoped=true&"
var script = {}
import style0 from "./eight.vue?vue&type=style&index=0&id=52878398&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52878398",
  null
  
)

export default component.exports